'use client';
var Refresh;
(function(Refresh) {
    /** Выполнить запрос при монтировании компонента */ Refresh[Refresh["OnMount"] = 0] = "OnMount";
    /** Выполнить запрос только при изменении пары [query, persist] */ Refresh[Refresh["OnQueryChanges"] = 1] = "OnQueryChanges";
    /** Выполнить при монтировании и изменении пары [query, persist] */ Refresh[Refresh["OnMountsAndQueryChanges"] = 2] = "OnMountsAndQueryChanges";
    /** Не выполнять никогда, только ручные запросы с помощью функции refresh */ Refresh[Refresh["Never"] = 3] = "Never";
})(Refresh || (Refresh = {}));

export { Refresh };
